import useSWRMutation from "swr/mutation";
import { API_REST_METHODS } from "../../../common/constants";
import { fetcher } from "../../../common/hooks";
import { DeviceUnassignment } from "../models";

export const useUpdateBulkDeviceUnassignments = ({
    companyId,
    locationId,
    onSuccess,
    onError,
}: {
    companyId: string;
    locationId: string;
    onSuccess?: () => void;
    onError?: (err: any, key: string) => void;
}) => {
    const {
        trigger: triggerUpdateBulkDeviceUnassignments,
        isMutating: isLoadingUpdateBulkDeviceUnassignments,
    } = useSWRMutation(
        `/api/device-management/v1/companies/${companyId}/locations/${locationId}/deviceAssignments/unassign-bulk`,
        (
            url: string,
            {
                arg,
            }: {
                arg: DeviceUnassignment[];
            }
        ) =>
            fetcher(url, {
                options: {
                    method: API_REST_METHODS.PUT,
                    body: JSON.stringify(arg),
                },
            }),
        {
            onSuccess,
            onError,
        }
    );

    return {
        triggerUpdateBulkDeviceUnassignments,
        isLoadingUpdateBulkDeviceUnassignments,
    };
};
